<template>
  <div class="vendor-trends-item-wrapper">
    <div class="dashboards-filters">
      <div class="dashboards-filters">
        <strong>{{ title }}</strong>
      </div>
      <div class="dashboards-filters dashboards-filters-date date-simple">
        <date-picker
          v-model="params.creation_date"
          format="D MMM"
          range-separator="-"
          :editable="false"
          :shortcuts="false"
          input-class="date-simple-input"
          range
          lang="en"
          class="dark"
        ></date-picker>
      </div>

      <div class="dashboards-filters">
        <type-switcher
          v-model="params.reportType"
          :options="reportTypeList"
          />
      </div>

      <div class="dashboards-filters">
        <language-picker
          :options="languagesList"
          v-model="params.sourceLanguage"
          placeholder="Source language"
        ></language-picker>
      </div>

      <div class="dashboards-filters">
        <language-picker
          :options="languagesList"
          v-model="params.targetLanguage"
          placeholder="Target language"
        ></language-picker>
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.industry_field"
          :options="industryFieldList"
          field-name="Name"
          placeholder="Industry sector(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.doc_type"
          :options="textCategoryList"
          field-name="Name"
          placeholder="Document type(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.qaModel"
          :options="qaModelsList"
          field-name="Name"
          placeholder="QA model(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.qaMethod"
          :options="qaMethodsList"
          field-name="Name"
          placeholder="Method(s)"
        />
      </div>
    </div>
    <template>
      <chart-constructor :options="chartOptions" />
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import props from './props';

export default Vue.extend({
  name: 'VendorTrendsMainItem',
  components: {
    'language-picker': () =>
      import('@/components/selectors/language/index.vue'),
    'filter-multiselect': () =>
      import('@/components/selectors/filterMultiple/index.vue'),
    'date-picker': () => import('vue2-datepicker'),
    'chart-constructor': () =>
      import('@/components/charts/chartConstructor/index.js'),
    'type-switcher': () => import('@/components/selectors/switcher/index.vue'),
  },
  props: {
    ...props,
  },
  data: () => ({
    chartOptions: Object(),
  }),
  watch: {
    value: {
      handler() {
        this.redrawGraph();
      },
      deep: true,
    },
  },
  computed: {
    params: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    genOptionsObject(series) {
      return {
        chart: {
          type: 'line',
        },
        title: {
          text: '',
        },
        tooltip: {
          formatter: function() {
            return `
              <p><b>Report ${moment.utc(this.x).format('DD.MM.YYYY')} (${this.series.name})</b></p>
              <br>
              <p>Risk level: ${this.point.risk}</p>
              <br>
              <p>QA level: ${this.point.qa.level}</p>
              <br>
              <p>QA score: ${this.point.qa.score}</p>
              <br>
              <br>
              <p><b>Errors</b></p>
              <br>
              <p>Total: ${this.y}</p>
              <br>
              <p>- serious: ${this.point.errors.serious}</p>
              <br>
              <p>- minor: ${this.point.errors.minor}</p>
              <br>
              <br>
              <p>Total words: ${this.point.words}</p>
            `;
          },
        },
        xAxis: {
          type: 'datetime',
        },
        legend: {
          enabled: true,
          layout: 'vertical',
          verticalAlign: 'middle',
          align: 'right',
        },
        series,
      };
    },
    redrawGraph() {
      this.getData().then((data) => {
        this.chartOptions = this.genOptionsObject(data);
      });
    },
    // Impementing this method in child components
    getData() {
      return new Promise((res) => {
        res(Array());
      });
    },
  },
  mounted() {
    this.redrawGraph();
  },
});
</script>

<style lang="scss">
.vendor-trends-item-wrapper {
  margin-bottom: 50px;
}
.dashboards-filters {
  margin-bottom: 0!important;
  flex-flow: row wrap;
  height: auto;

  &-date {
    margin-left: 40px;
  }
}
</style>
